import { render, staticRenderFns } from "./product-header-slider.vue?vue&type=template&id=14bc7e00"
import script from "./product-header-slider.vue?vue&type=script&lang=js"
export * from "./product-header-slider.vue?vue&type=script&lang=js"
import style0 from "./product-header-slider.vue?vue&type=style&index=0&id=14bc7e00&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports